import { Skeleton } from "@mui/material";
import { CreateTrucksSkeletonContent, CreateTrucksSkeletonRow } from "./CreateTrucksPage.styles";

const CreateTrucksSkeleton = () => {
	return (
		<CreateTrucksSkeletonContent>
			<div>
				<Skeleton
					variant="rectangular"
					width={240}
				/>
				<Skeleton
					variant="rectangular"
					width={120}
				/>
			</div>
			<Skeleton
				variant="rectangular"
				height={29}
			/>
			<div>
				{Array.from({ length: 10 }).map((item) => (
					<CreateTrucksSkeletonRow key={`item: ${item}`}>
						<Skeleton variant="rectangular" />
						<Skeleton variant="rectangular" />
						<Skeleton variant="rectangular" />
						<Skeleton variant="rectangular" />
						<Skeleton variant="rectangular" />
						<Skeleton variant="rectangular" />
						<Skeleton variant="rectangular" />
						<div>
							<Skeleton variant="rectangular" />
							<Skeleton variant="rectangular" />
						</div>
					</CreateTrucksSkeletonRow>
				))}
			</div>
		</CreateTrucksSkeletonContent>
	);
};

export default CreateTrucksSkeleton;
